let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("ffEVr"), load("3KV1Y"), load("2MuhG")]).then(() => parcelRequire('gelCt'));